module.exports = __webpack_public_path__ + "static/media/git.feb28c65.svg";